import { render, staticRenderFns } from "./purchaseDialog.vue?vue&type=template&id=f0036338"
import script from "./purchaseDialog.vue?vue&type=script&lang=js"
export * from "./purchaseDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports